import moment from 'moment';

declare module 'moment' {
  function getShortTime(date: Date): string;
  function getShortDate(date: Date): string;
  function getDayMonth(date: Date): string;
  function ceilDuration(ms: number, minuteInterval?: number): number;
  function getDurationString(start: Date, end: Date): string;
}

export const getShortTime = (date: Date) => {
  return moment(date).format('LT');
};
export const getFullDate = (date: Date) => {
  return moment(date).format('L');
};

export const getShortDate = (date: Date) => {
  return moment(date).format('dddd, D MMM');
};

export const getDayMonth = (date: Date) => {
  return moment(date).format('dddd D MMMM');
};

export const format = (date: Date, format: string) => {
  return moment(date).format(format);
};

export const setMinutes = (date: Date, minutes: number) => {
  return moment(date).minutes(minutes);
};

export const setHours = (date: Date, hours: number) => {
  return moment(date).hours(hours);
};

export const getLongDateTime = (date: Date) => {
  return format(date, 'LL, LT');
};

export const getHours = (date: Date) => {
  return moment(date).hours();
};
export const getMinutes = (date: Date) => {
  return moment(date).minutes();
};

export const getDurationString = (start: Date, end: Date) => {
  const startDate = moment(start).format('dddd D MMMM');
  const endDate = moment(end).format('dddd D MMMM');

  const startTime = moment(start).format('LT');
  const endTime = moment(end).format('LT');

  if (moment(start).isSame(end, 'day')) {
    return `${startDate}, ${startTime} - ${endTime}`;
  }

  return `${startDate}, ${startTime} - ${endDate}, ${endTime}`;
};

/**
 * Given a duration, ceil it to the nerest minuteInterval.
 *
 * example:
 * ms = 67 * 60 * 1000; // 67 minutes
 * minuteInterval = 10;
 * =>
 * return = 70 * 60 * 1000; // 70 min
 * @param  {Number} ms             [
 * @param  {Number} [minuteInterval=10≈
 * @return {Number} duration in ms ceiled to the  upper minuteInterval
 */
const ceilDuration = (ms: number, minuteInterval = 10) => {
  const duration = moment.duration(ms);
  const minutes = duration.minutes();
  const rest = minutes % minuteInterval;
  if (rest > 0) {
    const add = minuteInterval - (minutes % minuteInterval);
    duration.add(add, 'minutes');
  }

  return duration.asMilliseconds();
};

moment.getShortTime = getShortTime;
moment.getShortDate = getShortDate;
moment.getDayMonth = getDayMonth;
moment.ceilDuration = ceilDuration;
moment.getDurationString = getDurationString;

export default moment;
